var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.50005 11.6999C7.87917 11.6999 9.20182 11.1521 10.177 10.1769C11.1522 9.20169 11.7 7.87905 11.7 6.49993C11.7 5.1208 11.1522 3.79816 10.177 2.82297C9.20182 1.84778 7.87917 1.29993 6.50005 1.29993C5.12092 1.29993 3.79828 1.84778 2.82309 2.82297C1.8479 3.79816 1.30005 5.1208 1.30005 6.49993C1.30005 7.87905 1.8479 9.20169 2.82309 10.1769C3.79828 11.1521 5.12092 11.6999 6.50005 11.6999ZM8.9096 5.65948C9.028 5.53689 9.09352 5.37269 9.09204 5.20227C9.09056 5.03184 9.0222 4.86881 8.90168 4.74829C8.78117 4.62778 8.61814 4.55942 8.44771 4.55794C8.27728 4.55646 8.11309 4.62197 7.9905 4.74038L5.85005 6.88083L5.0096 6.04038C4.88701 5.92197 4.72282 5.85646 4.55239 5.85794C4.38196 5.85942 4.21893 5.92778 4.09842 6.04829C3.9779 6.16881 3.90954 6.33184 3.90806 6.50227C3.90658 6.67269 3.9721 6.83688 4.0905 6.95948L5.3905 8.25948C5.51239 8.38133 5.67769 8.44979 5.85005 8.44979C6.02241 8.44979 6.18771 8.38133 6.3096 8.25948L8.9096 5.65948Z",
    fill: "#BCCCDC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.ac09a9c314f04811d7bd49c37c4e093b.svg";
export { ForwardRef as ReactComponent };